import axios from 'axios';

const { REACT_APP_PROFILING } = window.__RUNTIME_CONFIG__;

const client = axios.create({
    baseURL: REACT_APP_PROFILING,
    responseType: 'json'
});

export default client;